import { useScreenTheme } from '@/providers/ScreenThemeStateProvider/EventScreenThemeContext';
import { ScreenTextElement } from '../../components/ScreenTextElement';
import { ScreenImageElement } from '../../components/ScreenImageElement';

export function FanElement({
  elementId,
  editor,
}: {
  elementId: string;
  editor: boolean;
}) {
  const { state, dispatch } = useScreenTheme();
  const element = state.savedTheme.fanElements[elementId];

  if (!element) {
    return null;
  }

  const { type } = element;

  if (type === 'text') {
    return (
      <ScreenTextElement
        elementId={elementId}
        editor={editor}
        state={state}
        dispatch={dispatch}
      />
    );
  }

  if (type === 'image') {
    return (
      <ScreenImageElement
        elementId={elementId}
        editor={editor}
        state={state}
        dispatch={dispatch}
      />
    );
  }

  return null;
}
